import ImportMap from "@/DataImports/ImportMap.vue";
import ImportReview from "@/DataImports/ImportReview.vue";
import ImportsHubIndex from "@/DataImports/ImportsHubIndex.vue";
import ImportUpload from "@/DataImports/ImportUpload.vue";

export default [
  {
    path: "/imports",
    name: "ImportsHubIndex",
    component: ImportsHubIndex,
    // Keeps the sidebar's Imports link lit on the flow pages under it.
    meta: {
      activeRoutes: [
        "/imports/new",
        "/imports/:batchType/:id/map",
        "/imports/:batchType/:id/review"
      ]
    }
  },
  {
    path: "/imports/new",
    name: "ImportUpload",
    component: ImportUpload
  },
  {
    path: "/imports/:batchType/:id/map",
    name: "ImportMap",
    component: ImportMap
  },
  {
    path: "/imports/:batchType/:id/review",
    name: "ImportReview",
    component: ImportReview
  }
];
